export default __webpack_public_path__ + "static/assets/med_spheric_solid_02.bd06197c.png";